import type { FC } from 'react';
import { useEffect } from 'react';

import { useBoolean } from '@trend-dev/ui-libs-utils/hooks/useBoolean';
import { useUpdatedRef } from '@trend-dev/ui-libs-utils/hooks/useUpdatedRef';

import { useConferenceStore } from 'store/conference';
import { useSizeStore } from 'store/size';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import Loader from 'components/UI/Loader';

import { useDeviceWidth } from 'hooks/useDeviceWidth';
import { useRedirectOnConferenceOver } from 'hooks/useRedirectOnConferenceOver';

import Body from './Body';
import Bottom from './Bottom';
import CameraPermissionContext from './Bottom/Controls/CameraPermissionContext';
import { useMicrophonePermission } from './hooks/useMicrophonePermission';
import { useRedirectToPreparationPage } from './hooks/useRedirectToPreparationPage';
import Leave from './LeaveModal';
import Wrapper from './Wrapper';

const Call: FC = () => {
    const { videoCall } = useConferenceStore();
    const { triggerYM } = useYM();
    const triggerYMRef = useUpdatedRef(triggerYM);
    const { isDesktop, isLandscape } = useDeviceWidth();
    const { isFull } = useSizeStore();
    const renderBottom = isDesktop || !isLandscape || isFull;
    const getMicrophonePermission = useMicrophonePermission();
    const [hasMicrophonePermission, { on }] = useBoolean(false);
    const redirectToPreparationPage = useRedirectToPreparationPage();

    useRedirectOnConferenceOver();

    useEffect(() => {
        if (videoCall) {
            getMicrophonePermission().then(hasMicrophonePermission => {
                if (hasMicrophonePermission) {
                    on();
                    triggerYMRef.current({ goal: GoalType.CONFERENCE_PAGE_VIEW });
                } else {
                    redirectToPreparationPage();
                }
            });
        }
    }, [videoCall, redirectToPreparationPage]);

    if (!videoCall || !hasMicrophonePermission) return <Loader />;

    return (
        <Wrapper>
            <CameraPermissionContext>
                <Body />
                {renderBottom && <Bottom />}
            </CameraPermissionContext>
            <Leave />
        </Wrapper>
    );
};

export default Call;
